import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import ReactPaginate from 'react-paginate'
import { Translation } from 'react-i18next'
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from '@material-ui/core/'
import FilterFields from './../FilterFields'
import DropDownPagination from './../dropDownPagination'
import store from '../../store'
import { changeRowsPerPage } from '../../actions'
import FontAwesome from 'react-fontawesome'
import { stringToArray } from './stringArrayHandle.utils'

function SortableTable(props) {
  const {
    data,
    headerCells,
    defaultOrderBy,
    defaultOrder,
    enableFilters,
    classes,
    handleLightEntrepreneurPreview,
    setFavouriteEntrepreneurs
  } = props
  const [order, setOrder] = React.useState(defaultOrder)
  const [orderBy, setOrderBy] = React.useState(defaultOrderBy)
  const [page, setPage] = React.useState(0)
  const [customComparator, setCustomComparator] = React.useState(null)
  const [filters, setFilters] = React.useState({})

  const rowsToShow = store.getState().pagination.rowsPerPage

  const handleRequestSort = (event, property, _customComparator) => {
    const isAsc = orderBy === property && order === 'asc'
    const isDesc = orderBy === property && order === 'desc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(isDesc ? null : property)

    if (_customComparator) setCustomComparator(() => _customComparator)
    else if (customComparator !== null) setCustomComparator(null)
  }

  const handleChangePage = (event) => {
    setPage(event.selected)
  }

  const handleChangeFilterValue = (_filters) => {
    setFilters(_filters)
    setPage(0)
  }

  const filteredData =
    enableFilters && Object.keys(filters).length > 0
      ? filterData(data, headerCells, filters)
      : data

  const _rowsPerPage =
    Math.floor(rowsToShow) !== rowsToShow ||
    rowsToShow <= 0 ||
    isNaN(rowsToShow)
      ? 10
      : rowsToShow

  const _pageCount = !data
    ? null
    : Math.ceil(filteredData.length / _rowsPerPage)

  //pagination rows dropdown
  const [paginationRowValue, setPaginationRowValue] = React.useState(10)
  const changePagination = (e) => {
    setPaginationRowValue(e.target.value)
    store.dispatch(changeRowsPerPage(e.target.value))
    setPage(0)
  }
  
  React.useEffect(() => {
    store.dispatch(changeRowsPerPage(paginationRowValue))
    setPage(0)
  }, [paginationRowValue])

  return (
    <Translation>
      {(t) => (
        <div className={classes.root}>
          {enableFilters ? (
            <>
              <div className={classes.filters}>
                <div>
                  <FilterFields
                    headerCells={headerCells.filter((el) => el.filter)}
                    handleChangeFilterValue={handleChangeFilterValue}
                    data={data}
                  />
                </div>
                <div style={{ marginTop: 'auto' }}>
                  <DropDownPagination
                    paginationRowValue={paginationRowValue}
                    changePagination={changePagination}
                  />
                </div>
              </div>
            </>
          ) : null}
          <div className={classes.profileContainer}>
            {!filteredData || filteredData.length === 0
              ? null
              : !orderBy
              ? filteredData
                  .slice(
                    page * _rowsPerPage,
                    page * _rowsPerPage + _rowsPerPage
                  )
                  .map((row, index) => (
                    <LightEntrepreneurCard
                      t={t}
                      data={row}
                      key={index}
                      classes={classes}
                      onRequestSort={handleRequestSort}
                      handleLightEntrepreneurPreview={
                        handleLightEntrepreneurPreview
                      }
                      setFavouriteEntrepreneurs={setFavouriteEntrepreneurs}
                    />
                  ))
              : stableSort(
                  filteredData,
                  getComparator(order, orderBy, customComparator)
                )
                  .slice(
                    page * _rowsPerPage,
                    page * _rowsPerPage + _rowsPerPage
                  )
                  .map((row, index) => (
                    <LightEntrepreneurCard
                      t={t}
                      data={row}
                      key={index}
                      classes={classes}
                      handleLightEntrepreneurPreview={
                        handleLightEntrepreneurPreview
                      }
                      setFavouriteEntrepreneurs={setFavouriteEntrepreneurs}
                    />
                  ))}
          </div>
          {data.length > 0 ? (
            <ReactPaginate
              previousLabel={<i className="fa fa-chevron-left" />}
              nextLabel={<i className="fa fa-chevron-right" />}
              breakLabel={'...'}
              breakClassName={'break-me'}
              forcePage={page}
              pageCount={_pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handleChangePage}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
          ) : null}
        </div>
      )}
    </Translation>
  )
}

SortableTable.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.array.isRequired,
  /** A function that takes in row data and the row's index and returns a TableRow component*/
  createRowComponent: PropTypes.func.isRequired,
  headerCells: PropTypes.arrayOf(
    PropTypes.shape({
      /** Property name existing in the data that relates to this header*/
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      align: PropTypes.oneOf(['inherit', 'center', 'left', 'right', 'justify']),
      padding: PropTypes.oneOf(['none', 'normal', 'checkbox']),
      isSortable: PropTypes.bool,
      style: PropTypes.object,
      customComparator: PropTypes.func
    })
  ),
  defaultOrder: PropTypes.oneOf(['asc', 'desc']),
  /** id of the headerCell to order by default */
  defaultOrderBy: PropTypes.string,
  rowsPerPage: PropTypes.number,
  enableFilters: PropTypes.bool,
  dense: PropTypes.bool
}

SortableTable.defaultProps = {
  defaultOrderBy: null,
  defaultOrder: 'asc',
  enableFilters: false
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',

    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },
  table: {
    fontSize: '13px',
    borderTop: '2px solid #999'
  },
  cell: {
    fontSize: '13px',
    fontWeight: 'bold',
    color: '#333'
  },
  dense: {
    padding: '0px 8px'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: 'rotate(90deg)'
  },
  filters: {
    marginBottom: '24px',
    paddingBottom: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF'
  },
  invoiceFilter: {
    marginBottom: 0
  },
  filterButton: {
    paddingTop: theme.spacing(),
    paddingBottom: theme.spacing(),
    width: '100%',
    color: 'gray'
  },
  tablecell: {
    fontWeight: 1000,
    fontSize: '13px',
    maxWidth: '200px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    [theme.breakpoints.down('xs')]: {
      padding: '0 10px'
    }
  },
  profileContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '15px'
  },
  profileCard: {
    display: 'flex',
    flexDirection: 'column',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    borderRadius: '3px',
    padding: '15px',
    flex: '1 1 calc(50% - 10px)' /* Ensures two cards per row */,
    minWidth: '300px',
    maxWidth: '49%',
    '&:hover': {
      cursor: 'pointer',
      padding: '14px',
      border: '1px solid #44c0cc'
    }
  },
  profileCardInfo: {
    display: 'flex',
    gap: '15px',
    flex: '1 1 calc(50% - 20px)' /* Ensures two cards per row */,
    position: 'relative'
  },
  favorite: {
    position: 'absolute',
    top: '-10px',
    right: '-10px',
    fontSize: '20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer'
  },
  avatar: {
    width: '94px',
    height: '94px',
    borderRadius: '8px'
  },
  profileContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  h3: {
    margin: 0,
    fontWeight: 'bold',
    fontSize: '13px',
    color: '#000000'
  },
  title: {
    marginTop: '4px',
    fontSize: '13px',
    color: '#000000'
  },
  description: {
    color: '#7D7D7D',
    fontSize: '12px'
  },
  tags: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginTop: '10px'
  },
  span: {
    background: '#44C0CC 0% 0% no-repeat padding-box',
    color: '#FFFFFF',
    padding: '4px 10px',
    borderRadius: '8px',
    fontSize: '12px'
  },
  span1: {
    fontSize: '12px',
    color: '#7D7D7D'
  }
})

export default withStyles(styles)(SortableTable)

function SortableTableHead(props) {
  const { classes, order, orderBy, onRequestSort, headerCells, dense } = props

  const createSortHandler = (property, customComparator) => (event) => {
    onRequestSort(event, property, customComparator)
  }

  return (
    <Translation>
      {(t) => (
        <TableHead>
          <TableRow>
            {headerCells.map((headerCell) => {
              const _classNames = [classes.cell]
              if (headerCell.className) _classNames.push(headerCell.className)
              if (dense) _classNames.push(classes.dense)

              return headerCell.hide ? null : (
                <TableCell
                  className={classNames(_classNames)}
                  key={headerCell.id}
                  style={headerCell.style ?? null}
                  align={headerCell.align ?? 'inherit'}
                  padding={headerCell.padding ?? 'normal'}
                  sortDirection={orderBy === headerCell.id ? order : false}
                >
                  {typeof headerCell.isSortable === 'undefined' ||
                  headerCell.isSortable ? (
                    <TableSortLabel
                      active={orderBy === headerCell.id}
                      direction={orderBy === headerCell.id ? order : 'asc'}
                      onClick={createSortHandler(
                        headerCell.id,
                        headerCell.customComparator
                      )}
                    >
                      {t(headerCell.label)}
                      {orderBy === headerCell.id ? (
                        <span className={classes.visuallyHidden}>
                          {order === 'desc'
                            ? 'sorted descending'
                            : 'sorted ascending'}
                        </span>
                      ) : null}
                    </TableSortLabel>
                  ) : (
                    t(headerCell.label)
                  )}
                </TableCell>
              )
            })}
          </TableRow>
        </TableHead>
      )}
    </Translation>
  )
}

SortableTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string,
  dense: PropTypes.bool
}

function defaultComparator(a, b, orderBy) {
  return descendingComparator(a[orderBy], b[orderBy])
}

export function descendingComparator(a, b) {
  if (isNaN(a) || isNaN(b)) {
    return b.localeCompare(a)
  }
  if (b < a) return -1
  if (b > a) return 1
  return 0
}

function getComparator(order, orderBy, customComparator) {
  if (customComparator) {
    return order === 'desc'
      ? (a, b) => customComparator(a, b)
      : (a, b) => -customComparator(a, b)
  } else
    return order === 'desc'
      ? (a, b) => defaultComparator(a, b, orderBy)
      : (a, b) => -defaultComparator(a, b, orderBy)
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index])
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0])
    if (order !== 0) return order
    return a[1] - b[1]
  })
  return stabilizedThis.map((el) => el[0])
}

const filterData = (data, headerCells, filters) => {
  if (!filters || filters.length === 0) return data
  const filteredData = data.filter((row) => {
    let match = true
    headerCells
      .filter((cell) => cell.filter && typeof cell.filter === 'object')
      .forEach((cell) => {
        if (!filters[cell.id]) return

        //for a custom filter function
        if (cell.filter.function) {
          if (!cell.filter.function(row, filters[cell.id])) {
            match = false
          }
          return
        }

        switch (cell.filter.type) {
          case 'select1':
            if (!(row[cell.id].toString() === filters[cell.id].toString())) {
              match = false
            }
            return
          case 'selectLightEntrepreneur':
            if (!stringToArray(row[cell.id]).includes(filters[cell.id])) {
              match = false
            }
            return
          case 'string':
            if (
              !row[cell.id]
                .toString()
                .toLowerCase()
                .includes(filters[cell.id].toLowerCase())
            ) {
              match = false
            }
            return
        }
      })
    return match
  })
  return filteredData
}

const LightEntrepreneurCard = ({
  t,
  data,
  classes,
  handleLightEntrepreneurPreview,
  setFavouriteEntrepreneurs
}) => {
  const shortDescription =
    data.ShortDescription.length > 200
      ? data.ShortDescription.slice(0, 200) + '...'
      : data.ShortDescription
  const isFavorite = data.pinned_fav_lightentrepreneur === true
  const areaOfExpertiseArray = stringToArray(data.AreaOfExpertise ?? '').map(
    (el) => t(`employer.areaOfExpertiseList.${el}`)
  )

  const totalTags = areaOfExpertiseArray.length
  const visibleExpertises =
    totalTags > 3 ? areaOfExpertiseArray.slice(0, 3) : areaOfExpertiseArray

  return (
    <div
      className={classes.profileCard}
      onClick={() => handleLightEntrepreneurPreview(data.Id)}
    >
      <div className={classes.profileCardInfo}>
        <button
          className={classes.favorite}
          onClick={(e) => {
            e.stopPropagation()
            setFavouriteEntrepreneurs({
              leId: data.Id,
              isFavorite: isFavorite,
              leEmail: data.email
            })
          }}
        >
          {isFavorite ? (
            <FontAwesome name="heart" style={{ color: '#F67131' }} />
          ) : (
            <FontAwesome name="heart-o" style={{ color: '#F67131' }} />
          )}
        </button>
        <img
          src={
            data.user_profile_path !== null
              ? data.user_profile_path
              : '../../../images/blank-profile-picture.png'
          }
          alt="Petra Rajamäki"
          className={classes.avatar}
        />
        <div className={classes.profileContent}>
          <h3 className={classes.h3}>
            {data.firstname + ' ' + data.lastname}&nbsp;&nbsp;
            <FontAwesome name="star" style={{ color: '#ffd433' }} />
            &nbsp;
            {data.ratingsSummary?.overall_average_rating ||
              (data?.avg_rating_le > 0 && data?.avg_rating_le)}
            &nbsp;
            {data.ratingsSummary?.total_companies && (
              <span>({data.ratingsSummary?.total_companies})</span>
            )}
          </h3>
          <p className={classes.title}>{data.Title}</p>
          <span
            className={classes.description}
            dangerouslySetInnerHTML={{ __html: shortDescription }}
          ></span>
        </div>
      </div>
      <div className={classes.tags}>
        {visibleExpertises.map((el, index) => (
          <span
            key={index}
            style={{
              padding: '5px 17px',
              borderRadius: '8px',
              textAlign: 'center',
              backgroundColor: '#44c0cc',
              color: '#FFFFFF',
              fontSize: '13px'
            }}
          >
            {' '}
            {el}
          </span>
        ))}
        {totalTags > 3 ? (
          <span className={classes.span1}>
            +{totalTags - visibleExpertises.length}
          </span>
        ) : null}
      </div>
    </div>
  )
}
